import React, { Component } from 'react'
import { Modal, Button } from 'react-bootstrap'
import {reduxForm, Field, setSubmitFailed} from 'redux-form'
import { Row, Col } from 'react-bootstrap'
import { required } from '../../util/validationFunctions'
import ButtonChangeRecord from '../comun/button/ButtonChangeRecord'
import InputText from '../comun/form/InputText'
import InputTextArea from '../comun/form/InputTextArea'
import InputCheckBox from '../comun/form/InputCheckBox'
import './Empresa.scss'
import Dropzone from 'react-dropzone'
import { CloudUpload, Delete, Warning } from '@material-ui/icons'
import {permisos as permisosConstant} from '../../constants/permisos'

class ModalCentro extends Component {
  constructor (props) {
    super()
    this.state = {
      accepted: '',
      rejected: '',
      errorTipoCentro: false,
      imagen: '',
      customPictraq:  false,
      customAgView: false,
      usuarioAdmin: false,
      customDataSwine: false
    }
  }

  componentDidMount () {
    console.log('auth',this.props.auth)
    this.props.change('activo', true)
    if (this.props.auth.customizations && this.props.auth.customizations.find(customizacion => customizacion ==='PICTraq')) {      
      this.setState({customPictraq:true})
    }
    if (this.props.auth.customizations && this.props.auth.customizations.find(customizacion => customizacion ==='AgView')) {      
      this.setState({customAgView:true})
    }
    if (this.props.auth.nombreUsuario && this.props.auth.nombreUsuario == "gesipor360admin") {
      this.setState({usuarioAdmin:true})
    }
    if (this.props.auth.customizations && this.props.auth.customizations.find(customizacion => customizacion ==='DataSwine')) {      
      this.setState({customDataSwine:true})
    }
  }

  componentDidUpdate (prevProps) {    
    if (this.props.imagen !== prevProps.imagen){
      this.props.change({hidden: true})
      this.props.change({hidden: false})
    }

    if (this.props.formModalCentro !== prevProps.formModalCentro) {
      if (this.props.formModalCentro.values) {
        if (this.props.formModalCentro.values.principalCentro !== false || this.props.formModalCentro.values.procesadoCentro !== false || 
          this.props.formModalCentro.values.produccionCentro !== false) {
          this.setState({errorTipoCentro: false})
        } else {
          if (this.props.showModalCentro === true){
            this.props.dispatch(setSubmitFailed('ModalCentro'))
          }
        }
      }
    }

    if (this.props.dataCentro !== prevProps.dataCentro) {
      if (Object.keys(this.props.dataCentro).length > 0) {
        if (Object.keys(this.props.dataCentro.imagenCentro).length > 0) {
          if (this.props.dataCentro.imagenCentro.file !== null) {
            this.setState({accepted: this.props.dataCentro.imagenCentro.file.imagebase64})
            let file = {
              name: this.props.dataCentro.imagenCentro.name,
              file: {
                name: this.props.dataCentro.imagenCentro.name,
                path: this.props.dataCentro.imagenCentro.name,
                imagebase64: this.props.dataCentro.imagenCentro.file.imagebase64
              }
            }
            this.props.actions.uploadFileEmpresa(file.file)
          }
        }
      }
    }

    if (this.props.dataCentroDuplicar !== prevProps.dataCentroDuplicar) {
      if (Object.keys(this.props.dataCentroDuplicar).length > 0) {
        if (Object.keys(this.props.dataCentroDuplicar.imagenCentro).length > 0) {
          if (this.props.dataCentroDuplicar.imagenCentro.file !== null) {
            this.setState({accepted: this.props.dataCentroDuplicar.imagenCentro.file.imagebase64})
            let file = {
              name: this.props.dataCentroDuplicar.imagenCentro.name,
              file: {
                name: this.props.dataCentroDuplicar.imagenCentro.name,
                path: this.props.dataCentroDuplicar.imagenCentro.name,
                imagebase64: this.props.dataCentroDuplicar.imagenCentro.file.imagebase64
              }
            }
            this.props.actions.uploadFileEmpresa(file.file)
          }
        }
      }
    }
  }

  submitNuevoCentro (values) {
    this.setState({errorTipoCentro: false})
    if (Object.keys(this.props.dataCentro).length > 0) {
      if (Object.keys(this.props.imagen).length === 0) {
        values.imagenCentro = this.props.dataCentro.imagenCentro
      } else {
        values.imagenCentro = this.props.imagen
      }
      this.props.actions.editarCentro(values)
    } else if (Object.keys(this.props.dataCentroDuplicar).length > 0) {
      values.imagenCentro = this.props.dataCentroDuplicar.imagenCentro
      this.props.actions.submitNuevoCentro(values)
    } else {
      values.imagenCentro = this.props.imagen
      if (this.props.submitSucceeded !== true) {
        this.props.actions.submitNuevoCentro(values)
      }
    }
    
    this.setState({accepted: ''})
  }

  guardarYnuevoCentro(values){
    this.props.actions.guardarYnuevoCentro(values)
  }

  onDrop (fileToUpload, rejectedFiles) {
    if (fileToUpload.length === 0 && rejectedFiles.length > 0) {
      this.setState({hasInvalidFile: true})
    } else {
      this.setState({accepted: fileToUpload.accepted[0]})
      if (fileToUpload.accepted.length > 0) {
        var reader = new FileReader();
        reader.onloadend = () => {
          var imagebase64=reader.result
          fileToUpload.accepted[0].imagebase64 = imagebase64
          this.setState({accepted: imagebase64})
        }
        this.props.actions.uploadFileEmpresa(fileToUpload.accepted[0])
        reader.readAsDataURL(fileToUpload.accepted[0])
      }
    }
  }

  eliminaImagen () {
    this.setState({accepted: ''})
  }

  cerrarModalCentro () {
    this.props.actions.cerrarModalCentro()
    this.setState({accepted: ''})
    let valors = {
      activo: true
    }
    this.props.initialize(valors)
  }

  render () {
    const {
      t, handleSubmit, listCentros, showModalCentro, dataCentro, duplicar, urlRecursos, actions: {recuperarDatosCentro, cerrarModalCentro}
    } = this.props

    return (
      <Modal show={showModalCentro} onHide={() => this.cerrarModalCentro()} backdrop="static" aria-labelledby="contained-modal-title-lg" className="modal-empresa">
      <form className="form-empresa">
        <Modal.Header closeButton>
          <Modal.Title>
          {
            Object.keys(this.props.dataCentro).length > 0 ? 
            t('EMPRESA.MODAL.TITULO_EDITAR')
            :
            t('EMPRESA.MODAL.TITULO_NUEVO')
          }
          </Modal.Title>
          {dataCentro && dataCentro.idCentro && (
            <ButtonChangeRecord list={listCentros} idElemento="idCentro" currentId={dataCentro.idCentro} getNextRecord={recuperarDatosCentro} />
          )}
        </Modal.Header>
        <Modal.Body>
          <Row>
              <Field
                colSm={4}
                id="nombreCentro"
                name="nombreCentro"
                component={InputText}
                controlLabel={t('EMPRESA.MODAL.NOMBRE') + '*'}
                customClass='campo-modal-centro'
                validate={required}
                maxLength={true}
                valorMaxLength={100}
              />
              <Field
                colSm={4}
                id="regaCentro"
                name="regaCentro"
                component={InputText}
                controlLabel={t('EMPRESA.MODAL.CODIGO_REGA')}
                customClass='campo-modal-centro'
                maxLength={true}
                valorMaxLength={30}
              />
              <Field
                colSm={4}
                id="cifCentro"
                name="cifCentro"
                component={InputText}
                controlLabel={t('EMPRESA.MODAL.CIF')}
                customClass='campo-modal-centro'
                maxLength={true}
                valorMaxLength={20}
              />
              <Field
                colSm={4}
                id="direccionCentro"
                name="direccionCentro"
                component={InputText}
                controlLabel={t('EMPRESA.MODAL.DIRECCION')}
                customClass='campo-modal-centro'
                maxLength={true}
                valorMaxLength={100}
              />
              <Field
                colSm={4}
                id="cpCentro"
                name="cpCentro"
                component={InputText}
                controlLabel={t('EMPRESA.MODAL.CP')}
                customClass='campo-modal-centro'
                maxLength={true}
                valorMaxLength={10}
              />
              <Field
                colSm={4}
                id="localidadCentro"
                name="localidadCentro"
                component={InputText}
                controlLabel={t('EMPRESA.MODAL.LOCALIDAD')}
                customClass='campo-modal-centro'
                maxLength={true}
                valorMaxLength={50}
              />
              <Field
                colSm={4}
                id="provincia"
                name="provincia"
                component={InputText}
                controlLabel={t('EMPRESA.MODAL.PROVINCIA')}
                customClass='campo-modal-centro'
                maxLength={true}
                valorMaxLength={50}
              />
              <Field
                colSm={4}
                id="paisCentro"
                name="paisCentro"
                component={InputText}
                controlLabel={t('EMPRESA.MODAL.PAIS')}
                customClass='campo-modal-centro'
                maxLength={true}
                valorMaxLength={50}
              />
              <Field
                colSm={4}
                id="telefonoCentro"
                name="telefonoCentro"
                component={InputText}
                controlLabel={t('EMPRESA.MODAL.TELEFONO')}
                customClass='campo-modal-centro'
                maxLength={true}
                valorMaxLength={50}
              />
              {/* <Field
                colSm={4}
                id="faxCentro"
                name="faxCentro"
                component={InputText}
                controlLabel={t('EMPRESA.MODAL.FAX')}
                customClass='campo-modal-centro'
                maxLength={true}
                valorMaxLength={50}
              /> */}
              <Field
                colSm={4}
                id="emailCentro"
                name="emailCentro"
                component={InputText}
                controlLabel={t('EMPRESA.MODAL.EMAIL')}
                customClass='campo-modal-centro'
                maxLength={true}
                valorMaxLength={100}
              />
              <Field
                colSm={4}
                id="webCentro"
                name="webCentro"
                component={InputText}
                controlLabel={t('EMPRESA.MODAL.WEB')}
                customClass='campo-modal-centro'
                maxLength={true}
                valorMaxLength={50}
              />
              <Field
                colSm={4}
                id="codigoGenetico"
                name="codigoGenetico"
                component={InputText}
                controlLabel={t('EMPRESA.MODAL.CODIGO_GENETICO')}
                customClass='campo-modal-centro'
                maxLength={true}
                valorMaxLength={30}
              />

              <Field
                colSm={4}
                id="numeroSerie"
                name="numeroSerie"
                component={InputText}
                controlLabel={t('EMPRESA.MODAL.NUMERO_SERIE')}
                customClass='campo-modal-centro'
                maxLength={false} 
                disabled={!this.state.usuarioAdmin}               
              />
              
              { this.state.customPictraq && <Field
                colSm={4}
                id="farmId"
                name="farmId"
                component={InputText}
                controlLabel={t('EMPRESA.MODAL.PIC_FARM_ID')}
                customClass='campo-modal-centro'
                maxLength={true}
                valorMaxLength={50}
              />}
              <Field
                id="hidden"
                name="hidden"
                colSm={0}
                inline
                component={InputCheckBox}
                claseActivo="hidden"
              />
              <div className="clearfix"></div>
              { this.state.customAgView && <Field
                colSm={4}
                id="agViewClientId"
                name="agViewClientId"
                component={InputText}
                controlLabel={t('EMPRESA.MODAL.AGVIEW_CLIENT_ID')}
                customClass='campo-modal-centro'
                maxLength={true}
                valorMaxLength={100}
              />}
              { this.state.customAgView && <Field
                colSm={4}
                id="agViewClientSecret"
                name="agViewClientSecret"
                component={InputText}
                controlLabel={t('EMPRESA.MODAL.AGVIEW_CLIENT_SECRET')}
                customClass='campo-modal-centro'
                maxLength={true}
                valorMaxLength={300}
              />}
              { this.state.customDataSwine && <Field
                colSm={4}
                id="dataSwineUrl"
                name="dataSwineUrl"
                component={InputText}
                controlLabel="dataSwineUrl"
                customClass='campo-modal-centro'                
              />}
              { this.state.customDataSwine && <Field
                colSm={4}
                id="dataSwineApiKey"
                name="dataSwineApiKey"
                component={InputText}
                controlLabel="dataSwineApiKey"
                customClass='campo-modal-centro'             
              />}
              {/* <div className="tipo-centro">
                <p><b>{t('EMPRESA.MODAL.TIPO_CENTRO')}</b></p>
                <Field
                  id="produccionCentro" 
                  name="produccionCentro"
                  colSm={4}
                  inline
                  component={InputCheckBox}
                  claseActivo="onoffswitch-label"
                  controlLabel={t('EMPRESA.MODAL.PRODUCCION')}
                />
                <Field
                  id="procesadoCentro"
                  name="procesadoCentro"
                  colSm={4}
                  inline
                  component={InputCheckBox}
                  claseActivo="onoffswitch-label"
                  controlLabel={t('EMPRESA.MODAL.PROCESADO')}
                />
                <Field
                  id="principalCentro"
                  name="principalCentro"
                  colSm={4}
                  inline
                  component={InputCheckBox}
                  claseActivo="onoffswitch-label"
                  controlLabel={t('EMPRESA.MODAL.PRINCIPAL')}
                />
                {
                  this.state.errorTipoCentro === true ? (
                    <span><Warning />{t('EMPRESA.MODAL.ERROR_DEBE_HABER_TIPO_CENTRO')}</span>
                  ) : null
                }
              </div>
              <div className="clearfix"></div> */}
              <Field
                id="activo"
                name="activo"
                colSm={8}
                inline
                component={InputCheckBox}
                claseActivo="onoffswitch-label"
                controlLabel={t('EMPRESA.MODAL.ACTIVO')}
              />
              <Col sm={4}>
               <div className="imagenEmpresa">
                <div className="content-dropzone">
                  <Dropzone
                    accept="image/jpeg, image/png"
                    onDrop={(accepted, rejected) => { this.onDrop({ accepted, rejected })}}
                    maxSize={2000000}
                    onDropRejected={this.onDropRejected}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div {...getRootProps()}  className="dropzone">
                        <input {...getInputProps()} />
                        <CloudUpload/>
                      </div>
                    )}
                  </Dropzone>
                  {
                    (this.state.accepted !== '' && this.state.accepted !== undefined) ? (
                      <div className="eliminar-imagen-empresa" onClick={this.eliminaImagen.bind(this)}>
                        <Delete/>
                      </div>
                    ) : null
                  }
                  <div className="imagen-perfil-empresa">
                  {
                    this.state.accepted !== '' && this.state.accepted !== undefined ? (
                      <img src={this.state.accepted} />
                    ) : (
                      <img src={urlRecursos + 'imagen-firma.jpg'} />
                    )
                  }
                  </div>
                  <p className={this.state.rejected === '' ? 'error-upload-img-oculto' : 'error-upload-img-visible'}>Imagen desamiado grande</p>
                </div>
              </div>
            </Col>


          </Row>
        </Modal.Body>
        <Modal.Footer>
          {
            /*this.props.dataCentro && (
              <Button type="button" className="btn btn-white" onClick={handleSubmit(duplicar)}>{t('EMPRESA.MODAL.DUPLICAR')}</Button>
            )*/
          }
          {
            /*!this.props.dataCentro && (
              <Button type="button" className="btn btn-primary" onClick={handleSubmit(this.guardarYnuevoCentro.bind(this))}>{t('EMPRESA.MODAL.GUARDAR_Y_NUEVO')}</Button>
            )*/
          }
          <Button
            type="button"
            onClick={handleSubmit(this.submitNuevoCentro.bind(this))}
            className={"btn btn-primary" + ((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.EMPRESA_CENTROS] < 2) ? ' disabled' : '')}
            disabled={(this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.EMPRESA_CENTROS] < 2)}
          >{t('EMPRESA.MODAL.GUARDAR')}</Button>
          <Button type="button" className="btn btn-white" onClick={() => this.cerrarModalCentro()}>{t('EMPRESA.MODAL.CANCELAR')}</Button>
        </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default (reduxForm({
  form: 'ModalCentro',
})(ModalCentro))